import { Component, OnInit } from '@angular/core';
import { UserContextService } from './core/service/user-context.service';
import { RouteStateService } from './core/service/route-state.service';
import { SessionService } from './core/service/session.service';
import { Router, NavigationEnd } from '@angular/router';
// import wind from '../assets/104209.js';

declare var ext1: Window;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'pmang';
  disabled: any = true;

  value1: string;

  value2: string;

  value3: string;

  value4: string;

  value5: any = 'Disabled';

  constructor(
    private routeStateService: RouteStateService,
    private userContextService: UserContextService,
    private sessionService: SessionService,
    private router: Router
  ) {
    this.sessionService.setItem('ng-app-language', 'en');
    /*    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
         window['Appcues'].page();
      }
    })*/
  }

  ngOnInit(): void {
    const user = this.userContextService.getUser();
    if (user) {
      this.routeStateService.add('Dashboard', '/main/dashboard', null, true);
      return;
    }
  }
}
